import type { CustomIconProps } from '../CustomIcon';

export const GiveBackIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M7.714 11.85 4.5 15.085 9.325 20l1.037-1.134c.3-.329.725-.516 1.17-.516h3.735c1.85 0 3.58-.913 4.625-2.44l2.886-4.217a1.4 1.4 0 0 0-2.157-1.772l-3.05 3.116c0-.937-.76-1.697-1.697-1.697H8.939c-.46 0-.9.184-1.225.51Z'
      fill={color}
    />
    <path
      d='M11.816 14.734h4.058c.937 0 1.696-.76 1.696-1.697m0 0c0-.937-.76-1.697-1.696-1.697H8.939c-.46 0-.9.184-1.225.51L4.5 15.085 9.325 20l1.037-1.134c.3-.329.725-.516 1.17-.516h3.735c1.85 0 3.58-.913 4.625-2.44l2.886-4.217a1.4 1.4 0 0 0-2.157-1.771l-3.05 3.115Z'
      stroke={secondaryColor}
      strokeWidth={1.5}
    />
    <path
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinejoin='round'
      d='m4 14 5.98 5.98-2.99 2.991-5.98-5.98z'
    />
    <rect x={9} y={1} width={7} height={7} rx={2} fill={color} stroke={color} strokeWidth={1.5} />
    <circle cx={12.5} cy={4.5} r={1.5} stroke={secondaryColor} strokeWidth={1.5} />
  </svg>
);
